// extracted by mini-css-extract-plugin
export default {"button":"switchSitesButton_button__xwFmB"};